import { Button, Grid } from "@mui/material";
import CardHESP from "../CardHESP/CardHESP";
import CardHESPTitle from "../CardHESP/CardHESPTitle";
import { Add } from "@mui/icons-material";
import { GetDatacenter_datacenter_tla_installContexts } from "../../views/App/__generated__/GetDatacenter";
import { navigate } from "@reach/router";
import { THEO_ID } from "../../views/App/AppRoot";
import { useState } from "react";
import TLADatacenterInstallContextsItem from "./TLADatacenterInstallContextsItem";
import TLAUpdateInstallContextDialog from "./TLAUpdateInstallContextDialog";
import TLARemoveInstallContextDialog from "./TLARemoveInstallContextDialog";

interface Props {
    datacenterId: string;
    installContexts: GetDatacenter_datacenter_tla_installContexts[];
}

export default function TLADatacenterInstallContexts({ installContexts, datacenterId }: Props): JSX.Element {
    const [selectedInstallCtx, setSelectedInstallCtx] = useState<
        GetDatacenter_datacenter_tla_installContexts | undefined
    >(undefined);

    const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);
    const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);

    return (
        <>
            <CardHESP>
                <CardHESPTitle
                    title="Install contexts"
                    button={
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Add />}
                            onClick={() =>
                                navigate(`/app/${THEO_ID}/tla/data-centers/${datacenterId}/install-contexts/create`)
                            }
                        >
                            Add
                        </Button>
                    }
                />
                <Grid container spacing={2} style={{ marginTop: "1px" }}>
                    {installContexts.length === 0 && (
                        <Grid item xs={12}>
                            No install contexts connected
                        </Grid>
                    )}
                    {installContexts.map((ctx) => (
                        <Grid item xs={12} key={`install-ctx-${ctx.id}`}>
                            <TLADatacenterInstallContextsItem
                                datacenterId={datacenterId}
                                isntallContext={ctx}
                                onDeleteClick={() => {
                                    setSelectedInstallCtx(ctx);
                                    setOpenRemoveDialog(true);
                                }}
                                onEditClick={() => {
                                    setSelectedInstallCtx(ctx);
                                    setOpenEditDialog(true);
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </CardHESP>
            {selectedInstallCtx && (
                <>
                    <TLARemoveInstallContextDialog
                        installContextId={selectedInstallCtx.id}
                        name={selectedInstallCtx.name ?? ""}
                        datacenterId={datacenterId}
                        open={openRemoveDialog}
                        onClose={() => setOpenRemoveDialog(false)}
                    />
                    <TLAUpdateInstallContextDialog
                        datacenterId={datacenterId}
                        installContext={selectedInstallCtx}
                        onClose={() => setOpenEditDialog(false)}
                        open={openEditDialog}
                    />
                </>
            )}
        </>
    );
}
